export default () => ({
  trigger: {
    name: 'promo_box.show_promobox',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
